import React from "react"
import PropTypes from "prop-types"
import {Row, Col} from "@irati/ui/src/Layout"
import styled from "styled-components"

import {Label} from "@irati/ui/src/Typography"

const StyledRow = styled(Row)`
  line-height: 1;
`

const DealSuccessTicketLabelValue = ({label, value, xsHidden, smHidden, className}) => {
  return (
    <StyledRow className={className}>
      <Col xs={12} xsHidden={xsHidden} smHidden={smHidden}>
        <Label>{label}:</Label>
        <Label display="inline-block" marginLeft={1}>
          {value}
        </Label>
      </Col>
    </StyledRow>
  )
}

DealSuccessTicketLabelValue.defaultProps = {
  xsHidden: false,
  smHidden: false,
  className: null
}

DealSuccessTicketLabelValue.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  xsHidden: PropTypes.bool,
  smHidden: PropTypes.bool,
  className: PropTypes.string
}

export default DealSuccessTicketLabelValue
